import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonos-title" className="w-full bg-cream-200 px-5 py-20 sm:py-24" data-id="element-15" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-content" data-id="element-16" data-mp="aua82hmprpv5">
        <div className="max-w-2xl text-center sm:text-left" data-id="element-17" data-mp="at8t422kuj85">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-rose-500" data-id="element-18" data-mp="fslhir93jycu">
            <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-19" data-mp="1wht5ekwmk8a" />
            Incluidos hoy
          </p>
          <h2 id="bonos-title" className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-5xl" data-id="element-20" data-mp="5tvygv5gs7v0">
            Los 5 Bonos de implementación inmediata
          </h2>
        </div>

        <ul className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-21" data-mp="1mba0dd92a4p6">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col border-t border-rose-200 pt-5" data-id="element-22" data-mp="1r80ehv1b2q7y">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-rose-500" data-id="element-23" data-mp="3id54x7cwv5bb">
                {bonus.number}
              </p>
              <h3 className="mt-2 font-display text-2xl font-semibold text-plum-800" data-id="element-24" data-mp="3ddipcr9m1czc">
                {bonus.title}
              </h3>
              <p className="mt-2 text-base leading-relaxed text-plum-500" data-id="element-25" data-mp="3n4wkkmuj3qmo">{bonus.text}</p>
            </li>)}
        </ul>

        <p className="mt-12 flex flex-wrap items-baseline gap-x-4 gap-y-1 border-t border-rose-200 pt-8 text-base text-plum-500" data-id="element-26" data-mp="2zg3wfck5en2m">
          <span data-id="element-27" data-mp="2uiu0rf661f6c">
            Valor total de los 5 bonos: <span className="line-through" data-id="element-28" data-mp="38hbi8v5h9vft">$42.00</span>
          </span>
          <span className="font-semibold text-plum-800" data-id="element-29" data-mp="33hfduusvc1zq">Tu precio hoy: GRATIS</span>
        </p>
      </div>
    </section>;
}